import React, { useState } from 'react';
import './Chatbot.css';
import ChatbotModal from './ChatbotModal';
import { trackEvent } from '../../utils/analytics';

const Chatbot = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className="chatbot-button"
        onClick={() => {
          trackEvent("chatbot_opened", { source: "fab_button" });
          setOpen(true);
        }}
      >
        💬
      </div>
      {open && (
        <ChatbotModal
          onClose={() => {
            trackEvent("chatbot_closed");
            setOpen(false);
          }}
        />
      )}
    </>
  );
};

export default Chatbot;
